import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import DownloadReportModal from '../../subrouters/Reports/pages/Overview/components/DownloadReportModal';
import DownloadIcon from 'icons/Download.icon';
import { Button } from 'ncoded-component-library';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import DownloadStatusContext from 'providers/DownloadStatus/DownloadStatus.context';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { hasNotSeenDiscoveryFeature } from 'utils';
import { SECOND_RELEASE_DISCOVERING_FEATURE } from 'data/discoveringFeature';

import './ExportAnalyticsButton.styles.scss';

type ExportAnalyticsButtonProps = {
  className?: string;
  withExtendedSections?: boolean;
};

const ExportAnalyticsButton: React.FC<ExportAnalyticsButtonProps> = (props) => {
  const { className, withExtendedSections = false } = props;

  const { isAnalyticsExportInProgress, showAnalyticsExportInProgressBanner } =
    useContext(DownloadStatusContext);
  const {
    currentUser: { seenAnalyticsExportFeature },
    updatePreferences,
  } = useContext(CurrentUserContext);

  const [reportModal, reportModalRef] = useCallbackRef<ModalRef>();

  const classes = classNames(
    'export-analytics-button',
    {
      disabled: isAnalyticsExportInProgress,
      new: hasNotSeenDiscoveryFeature(
        seenAnalyticsExportFeature,
        SECOND_RELEASE_DISCOVERING_FEATURE,
      ),
    },
    className,
  );

  const { t } = useTranslation();

  const onClick = useCallback(() => {
    if (isAnalyticsExportInProgress) {
      showAnalyticsExportInProgressBanner();
      return;
    }

    reportModal?.open();

    if (seenAnalyticsExportFeature) return;

    updatePreferences({ seenAnalyticsExportFeature: true });
  }, [
    isAnalyticsExportInProgress,
    reportModal,
    seenAnalyticsExportFeature,
    updatePreferences,
    showAnalyticsExportInProgressBanner,
  ]);

  return (
    <>
      <Button className={classes} icon={DownloadIcon} onClick={onClick}>
        {t('exportAnalytics')}
      </Button>
      <DownloadReportModal
        ref={reportModalRef}
        withExtendedSections={withExtendedSections}
      />
    </>
  );
};

export default ExportAnalyticsButton;
